import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { AuthService } from '../../../core/auth.service';
import { Notifications, IconEnum, FromEnum, AlignEnum, NotificationTypeEnum } from '../../../providers/notifications';
import { Router } from '@angular/router';
import { Globals } from '../../../globals';
import swal from 'sweetalert2';

declare var $: any;

@Component({
    selector: 'app-privacy-policy-cmp',
    templateUrl: './privacy-policy.component.html',
})

export class AdminPrivacyPolicyComponent implements OnInit, OnDestroy {


    constructor(private element: ElementRef
        , private _auth: AuthService
        , public n: Notifications
        , public router: Router
        , public gb: Globals
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('login-page');
        body.classList.remove('off-canvas-sidebar');
    }
}

